<script lang="ts" setup>
import MaterialSymbolsShieldPersonOutlineRounded from "~icons/material-symbols/shield-person-outline-rounded";
import { useSchoolStore } from "@/store/school";
import { useSessionStore } from "@/store/session";
import type { TSchoolAdmin } from "@/assets/js/globalTypes";
import SchoolAdminHeader from "@/components/school/school-setup/school-administrators/SchoolAdminHeader.vue";
import SchoolAdminContent from "@/components/school/school-setup/school-administrators/SchoolAdminContent.vue";
import guideImage from "@/assets/image/school-setup-guide.png";
import { $t } from "@/i18n";
import { useDefaultStore } from "@/store";

definePage({
	name: "school.school-setup.school-administrators",
});

const defaultStore = useDefaultStore();
const schoolStore = useSchoolStore();
const sessionStore = useSessionStore();
// const schoolAdmins = ref<TSchoolAdmin[]>([]);
const suggestions = ref<TSchoolAdmin[]>([]);
const isLoading = ref(false);
const dataTableColumns = computed(() => [
	{
		header: $t("app.school.schoolSetup.schoolAdmins.fullname"),
		field: "usr_fullname",
	},
	{
		header: $t("app.school.schoolSetup.schoolAdmins.email"),
		field: "usr_email",
	},
	{
		header: $t("app.school.schoolSetup.schoolAdmins.title"),
		field: "usr_schoolrole",
	},
	{
		header: $t("app.school.schoolSetup.schoolAdmins.lastLogin"),
		field: "usr_lastlogin",
	},
]);
const speechBubbleText = $t("app.school.schoolSetup.schoolAdmins.guideText", {
	supportEmail: defaultStore.supportEmail,
});

async function getSuggestions(q: string) {
	suggestions.value = await schoolStore.fetchSchoolAdmins({
		scl_id: sessionStore.userData.scl_id,
		usr_fullname: q,
	});
}

// function handleOptionSelect(selected: TSchoolAdmin) {
// 	getSchoolAdmins(sessionStore.userData.scl_id, selected.usr_fullname);
// }

// async function handleSearchOnClick(q: string | TSchoolAdmin) {
// 	q = typeof q === "string" ? q : q.usr_fullname;

// 	getSchoolAdmins(sessionStore.userData.scl_id, q);
// }

async function getSchoolAdmins(scl_id: number, q?: string) {
	isLoading.value = true;
	// schoolAdmins.value = await schoolStore.fetchSchoolAdmins({
	// 	scl_id,
	// 	usr_fullname: q,
	// 	ignore_pagination: true,
	// });
	suggestions.value = await schoolStore.fetchSchoolAdmins({
		scl_id,
		usr_fullname: q,
		ignore_pagination: true,
	});
	isLoading.value = false;
}

onMounted(async () => {
	if (sessionStore.userData && sessionStore.userData.scl_id) {
		getSchoolAdmins(sessionStore.userData.scl_id);
	}
});
</script>

<template>
	<div id="school-administrators">
		<school-management
			:page-icon="MaterialSymbolsShieldPersonOutlineRounded"
			:page-title="$t('app.school.schoolSetup.schoolAdmins.pageTitle')"
			:create-btn-visible="false"
			:accordion-header="SchoolAdminHeader"
			:items="suggestions"
			:accordion-content="SchoolAdminContent"
			:colums="dataTableColumns"
			:guide-image="guideImage"
			:speech-bubble-text="speechBubbleText"
			:is-loading="isLoading"
			:action-btn-visible="false"
			@search-input="(e) => getSuggestions(e)"
		/>
	</div>
</template>

<style lang="scss" scoped>
#school-administrators {
	max-height: calc(100vh - $nav-top-bar - 1px);
	overflow-y: auto;
	overflow-x: auto;
	box-sizing: border-box;
}

@media screen and (width >= 768px) {
	#school-administrators {
		max-width: calc(100vw - $mini-sidebar-width);
	}
}

@media screen and (width >= 1157px) {
	#school-administrators {
		max-width: calc(100vw - $expanded-sidebar-width);
	}
}
</style>
